import { NoSsr } from '@cian/react-utils';
import { IStyleConfig, mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './ChatPrettyDate.css';
import { getPrettyChatDate } from '../../utils/prettyDate';

interface IChatPrettyDateProps {
  date: number;
  showOnlyTime?: boolean;
  showTime?: boolean;
  showFullDateWithTime?: boolean;
  containerStyles?: IStyleConfig;
}

export const ChatPrettyDate: React.FC<IChatPrettyDateProps> = ({
  date,
  showOnlyTime,
  showTime,
  showFullDateWithTime,
  containerStyles,
}) => {
  const [prettyDate, setPrettyDate] = React.useState('');

  React.useEffect(
    () =>
      setPrettyDate(
        getPrettyChatDate(date, {
          showFullDateWithTime,
          showOnlyTime,
          showTime,
        }),
      ),
    [date, showFullDateWithTime, showOnlyTime, showTime],
  );

  return (
    <NoSsr>
      <span {...mergeStyles(styles['container'], containerStyles)}>{prettyDate}</span>
    </NoSsr>
  );
};
